export default __webpack_public_path__ + "static/media/skippedmeal_6.92dbc1e8.jpg";